var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-35a)" },
      React.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "#14C17B" }),
      React.createElement("path", { d: "M7.75745 12.4142L9.87877 14.5355C10.2693 14.926 10.9025 14.926 11.293 14.5355L16.2427 9.58575", stroke: "#fff", strokeWidth: "2", strokeLinecap: "round" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-35a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })
      )
    )
  );
});